/* global Vue, Zepto, basicInfo, dayjs, share, utils */;
(function (window, Vue, $, basicInfo, dayjs, utils) {
    const PAGE_SIZE = 20
    // 二次分享
    window.shareApi.init({
        env: share.env // 测试环境test，正式环境production
    });
    let vm = new Vue({
        el: '#app',
        data: {
            toolsList: ['龙头狙击股票池'],
            nameList: ['李*', '21世纪**', '古龙**', '天天**', '牛**'],
            fullStoryFlag: false,
            hotArticleList: [],//文章
            multilevelComments: [],//评论
            articleRecord: {},//战绩榜
            contentLabels: [],//所属专栏的标签数量
            rightusernum: 128,//所属专栏购买人数，默认随便给了个值
            showPop:false,
            status:0,
            dvType:'',
        },
        methods: {
            /**
             * 随机选取头像
             */
            randomIndex() {
                return baseRandom(0, 3);
            },
            // 页面打开3秒后弹出弹窗
            showPopFunc(){
               $('.mask').removeClass('none')
            },
            closePop(){
                $('.mask').addClass('none')
            },
            gotoDownload(downloadUrl) {
                location.href = downloadUrl;
            },
            // 点击箭头查看全文
            viewFullStory() {

            },
            //热门文章
            getHotArticle(successCb, errorCb) {
                let reqObj = {}
                $.ajax({
                    type: 'POST',
                    url: './hotArticle',
                    contentType: 'application/json',
                    data: JSON.stringify(reqObj),
                    success: successCb,
                    error: errorCb
                });
            },
            //检测用户登录
            checkUserLogin() {
                let _self = this;
                let reqObj = {}
                $.ajax({
                    type: 'POST',
                    url: './checkUserLogin',
                    contentType: 'application/json',
                    data: JSON.stringify(reqObj),
                    success: function (res) {
                        if (res.ret === 0) {
                            if(res.data == 0){
                                setTimeout(_self.showPopFunc,3000);
                            }
                        } else {
                            console.log('checkUserLogin error',res.ret)
                            // utils.showToast({ content: '获取二级评论失败' });
                        }
                    },
                    error: function (err) {
                        console.log('checkUserLogin error 2',err)
                        // utils.showToast({ content: '获取二级评论失败' });
                    }
                });
            },
            // 热门文章查看详情
            gotoDetail(type, referid, anchor) {
                anchor = anchor || '';
                location.href = `${location.origin}/share/column?articleid=${referid}&from=${window.origin}`
            },
            gotoExternalLink(url, extra) {
                console.log("gotoExternalLink=============1", url, extra);
                if (typeof url === 'string') {
                    location.href = url;
                    // utils.checkTouristLogin((url) => {
                    //     upNativeComm.exec('WebView.open', {
                    //         url: url
                    //     });
                    // }, url);
                }
            },
            //热门评论
            getMultilevelComments(offset, size, referId, successCb, errorCb) {
                let reqObj = {
                    business: window.origin === 'topic' ? 'topic' : 'column',
                    bId: basicInfo.id,
                    offset,
                    size,
                    referId
                }
                $.ajax({
                    type: 'POST',
                    url: '/getMultilevelComments',
                    contentType: 'application/json',
                    data: JSON.stringify(reqObj),
                    success: successCb,
                    error: errorCb
                });
            },

            /**
           *
           * @param {*} replyIdx 被回复的一级评论 idx
           * @param {*} replyCommentId 被回复的一级评论 id
           */
            getReplyComments(replyIdx, replyCommentId) {
                let reqObj = {
                    business: window.origin === 'topic' ? 'topic' : 'column',
                    bId: basicInfo.id,
                    replyCommentId,
                    offset: 0,
                    size: 999, // 全量拉二级评论
                    referId: 0
                }
                $.ajax({
                    type: 'POST',
                    url: '/getReplyComments',
                    contentType: 'application/json',
                    data: JSON.stringify(reqObj),
                    success: function (res) {
                        if (res.ret === 0) {
                            vm.multilevelComments[replyIdx].bReply = res.data;
                        } else {
                            utils.showToast({ content: '获取二级评论失败' });
                        }
                    },
                    error: function () {
                        utils.showToast({ content: '获取二级评论失败' });
                    }
                });
            },
            // 获取战绩榜数据
            getIndexRecord(successCb, errorCb) {
                let reqObj = {}
                $.ajax({
                    type: 'POST',
                    url: '/share/getIndexRecord',
                    contentType: 'application/json',
                    data: JSON.stringify(reqObj),
                    success: successCb,
                    error: errorCb
                });
            },
            // 获取老师的投顾信息
            getTgContentServiceInfo(successCb, errorCb) {
                let reqObj = {
                    tgUpName: window.tgUpName,
                    id: parseInt(window.productId)
                }
                $.ajax({
                    type: 'POST',
                    url: '/tg/getTgContentServiceInfo',
                    contentType: 'application/json',
                    data: JSON.stringify(reqObj),
                    success: successCb,
                    error: errorCb
                });
            },
            // 判断用户有无权限
            queryUserRight(successCb, errorCb) {
                let reqObj = {}
                $.ajax({
                    type: 'POST',
                    url: '/tg/queryUserRight',
                    contentType: 'application/json',
                    data: JSON.stringify(reqObj),
                    success: successCb,
                    error: errorCb
                });
            },
            replaceDomain(url){
                try {
                    // 解析URL和当前域名
                    const urlObj = new URL(url);
                    const currentHost = window.location.hostname;

                    // 提取当前域名中.com前面的主体（如 upchina.com → upchina）
                    const currentMain = currentHost.split('.').slice(-2, -1)[0];
                    // 提取目标URL中.com前面的主体
                    const urlMain = urlObj.hostname.split('.').slice(-2, -1)[0];

                    // 验证是否都是.com域名
                    if (!currentHost.endsWith('.com') || !urlObj.hostname.endsWith('.com')) {
                        return window.loginUrl;
                    }

                    // 如果主体相同则直接返回原URL，否则替换主体部分
                    if (currentMain === urlMain) return url;

                    // 替换主域名并保留其他部分
                    const newHost = urlObj.hostname.replace(`${urlMain}.com`, `${currentMain}.com`);
                    return `${urlObj.protocol}//${newHost}${urlObj.pathname}${urlObj.search}${urlObj.hash}`;
                } catch (e) {
                    console.error('URL处理错误:', e);
                    return window.loginUrl;
                }
            },
            gotoLogin() {
                let backUrl = `${location.href}`;
                let gLoginUrl = this.replaceDomain(window.loginUrl);
                let loginUrl = `${gLoginUrl}?unique_id=${new Date().getTime()}&callback=${encodeURIComponent(backUrl)}`;
                window.location.href = loginUrl;
            },
            handleThemeArticle(){
                console.log('handleThemeArticle()');
                if (document.querySelector('.tctableHide') !== null) {
                    document.querySelector('.tctableHidezc').style.width = `${document.querySelector('.tctableHide').getBoundingClientRect().width}px`;
                    document.querySelector('.tctableHidezc').style.height = `${document.querySelector('.tctableHide').getBoundingClientRect().height}px`;

                    $('.tctableHidezc').on('click', function () {
                        //打开弹窗
                        location.href = "https://cdn.upchina.com/acm/202101/newsecondtqlq/index.html?tabindex=31";
                    })
                    // $('.tcxsStyle').on('click', function () {
                    //     // alert(window.tzxsID)
                    //     //打开弹窗
                    //     // location.href = `https://cdn.upchina.com/theme-front/h5-staging/dist/index.html#/clue/detail?id=${tzxsID}`;
                    //     location.href = `https://cdn.upchina.com/theme-front/h5/dist/index.html#/clue/detail?id=${tzxsID}`;
                    // })

                    //获取权限
                    $.ajax({
                        type: 'POST',
                        url: '/column/getVip',
                        contentType: 'application/json',
                        data: JSON.stringify({
                            mids: [2116, 2118]
                        }),
                        success: res => {
                            if (res.ifauth) {
                                document.querySelector('.tctableShow').classList.remove('hide');
                                document.querySelector('.tctableHide').classList.add('hide');
                                document.querySelector('.tctableHidezc').classList.add('hide');
                            }
                        },
                        error: function () {
                            // utils.showToast({ content: '更新' });
                        }
                    });
                }
            }
        },
        created: function () {
            this.getHotArticle(res => {
                if (res.ret === 0) {
                    this.hotArticleList = res.data;
                    // this.$nextTick(() => {
                    //     this.commentPosition = $('#tar_comments').offset().top;
                    // });
                }
            });
            this.getMultilevelComments(0, PAGE_SIZE, 0, res => {
                if (res.ret === 0) {
                    // this.commentPosition = $('#tar_comments').offset().top;
                    this.multilevelComments = res.data.list;
                }
            });
            // this.getIndexRecord(res => {
            //     if (res.ret === 0) {
            //         this.articleRecord = res.record;
            //     }
            // });
            this.getTgContentServiceInfo(res => {
                if (res.ret === 0) {
                    if (res.contentServices[0].contentLabels) {
                        this.contentLabels = res.contentServices[0].contentLabels;
                    }
                    if (res.rightUser) {
                        this.rightusernum = res.rightUser.data.length;
                    }
                }
            });
            this.queryUserRight(res => {
                if (res.ret === 0) {
                    this.status = res.status
                }
            })
            // this.checkUserLogin();
            // setTimeout(this.showPopFunc,3000)
            this.dvType = window.dvType;
        },
        mounted(){

            this.handleThemeArticle();
        },
        filters: {
            dateFormat(timestamps) {
                return utils.dateFormat(timestamps);
            },
            speDateFormat(timestamps) {
                return utils.speDateFormat(timestamps);
            }
        }
    });

    function baseRandom(lower, upper) {
        return lower + Math.floor(Math.random() * (upper - lower + 1));
    }
})(window, Vue, Zepto, basicInfo, dayjs, utils);
